// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"844":"a0a360b5904d7123","895":"bde01f7d76df312a","6321":"afec8e84557e0b97"}[chunkId] + ".css";
};